import { queryOptions } from '@tanstack/react-query';

import { $api } from '@shared/api';
import { keysToCamel } from '@shared/helpers';

import { getFinanceDashboardRefetchInterval } from '../model/getRefetchInterval';
import { FinanceDashboardApiResponse, FinanceDashboardCalculationState } from '../model/types';

export const financeDashboardApi = {
    getQueryOptions: (apiUrl: string, refreshVersion = 0) =>
        queryOptions({
            queryKey: ['finance-dashboard', apiUrl, refreshVersion],
            queryFn: async ({ signal }) => {
                const response = await $api.get<FinanceDashboardApiResponse>(apiUrl, {
                    signal,
                });

                return keysToCamel<FinanceDashboardCalculationState>(response.data.data);
            },
            refetchInterval: (query) => getFinanceDashboardRefetchInterval(query.state.data),
            refetchOnMount: true,
        }),
    restart: async (apiUrl: string) => {
        const response = await $api.get<FinanceDashboardApiResponse>(apiUrl, {
            params: { refresh: 1 },
        });

        return keysToCamel<FinanceDashboardCalculationState>(response.data.data);
    },
};
